import { CashbackReport } from "../modules/cashbackReport";

export const CashbackReportPage = () => {
  return <CashbackReport />;
};
